"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var keycodes_1 = require("@angular/cdk/keycodes");
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var entity_service_1 = require("../../service/api/entity.service");
var sis_entity_search_component_1 = require("../sis-entity-search/sis-entity-search.component");
var material_1 = require("@angular/material");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var SisMultiSelectEntitySearchComponent = /** @class */ (function (_super) {
    __extends(SisMultiSelectEntitySearchComponent, _super);
    function SisMultiSelectEntitySearchComponent(kbService, httpEntitySearchService, currentLanguageProvider, languageService) {
        var _this = _super.call(this, kbService, httpEntitySearchService) || this;
        _this.kbService = kbService;
        _this.httpEntitySearchService = httpEntitySearchService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.languageService = languageService;
        _this.separatorKeysCodes = [keycodes_1.ENTER, keycodes_1.COMMA];
        _this.selectable = true;
        _this.removable = true;
        _this.addOnBlur = false;
        _this.chipMaxWidth = 100;
        return _this;
    }
    SisMultiSelectEntitySearchComponent.prototype.ngOnInit = function () {
        this.chipMaxWidth = +this.entitiesFormFiled.underlineRef.nativeElement.offsetWidth - 100; //100 is size of action icons
    };
    SisMultiSelectEntitySearchComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['filterableEntity']) { // case, when user want to change filterable field
            this.reset();
            var nameMetaFieldIds$ = this.kbService.getNameMetaFieldIds(changes['filterableEntity'].currentValue, this.kbPrefix);
            var metaFields$ = this.kbService.getMetaFields(changes['filterableEntity'].currentValue, this.kbPrefix);
            var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
            var inputLanguages$ = this.languageService.getInputLanguages();
            var defaultLanguage$ = this.languageService.getDefaultLanguage();
            Observable_1.Observable.combineLatest(metaFields$, nameMetaFieldIds$, currentLanguage$, inputLanguages$, defaultLanguage$)
                .publishReplay(1).refCount()
                .pipe(operators_1.takeUntil(this.ngUnsubscribe))
                .subscribe(function (_a) {
                var metaFields = _a[0], nameMetaFieldIds = _a[1], currentLanguage = _a[2], inputLanguages = _a[3], defaultLanguage = _a[4];
                if (inputLanguages.some(function (inputLanguage) { return inputLanguage.getId() === currentLanguage.getId(); })) {
                    _this.currentLanguageId = currentLanguage.getId();
                }
                else {
                    _this.currentLanguageId = defaultLanguage.getId();
                }
                _this.nameFieldIds = nameMetaFieldIds;
                _this.initSortingOption(metaFields);
                _this.checkingFilterFieldsTypes(metaFields);
                _this.initFilteredCategoryInstanceFieldName(metaFields);
                _this.initEntitySearchInputFilterChangeHandler(false);
                _this.selectedEntities = [];
                changes['value'] && _this.initSelectedEntity(changes['value'].currentValue);
                _this.entitiesInput.nativeElement.value = '';
                _this.entitySearchCtrl.setValue('');
            });
        }
        else if (changes['value'] && changes['value'].currentValue.length === 0) { // case, when user want to reset multiselect entity field
            this.selectedEntities = [];
            this.entitySearchCtrl.setValue('');
        }
    };
    SisMultiSelectEntitySearchComponent.prototype.initSelectedEntity = function (selectedValues) {
        var _this = this;
        if (selectedValues !== undefined && selectedValues !== null && selectedValues.length > 0) {
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            filterBuilder.in(this.categoryIdentityFieldSystemName, selectedValues);
            this.httpEntitySearchService.loadEntitySearchItems(this.filterableEntity, this.filterFields, this.multilingualFields, this.nameFieldIds, this.categoryIdentityFieldSystemName, this.currentLanguageId, new idm_de_core_frontend_1.PagingOptions(0, selectedValues.length), null, filterBuilder.build(), null, this.kbPrefix)
                .pipe(operators_1.takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
                if (data.getData().length > 0) {
                    data.getData().forEach(function (entityDisplayName) {
                        _this.selectedEntities.push(entityDisplayName);
                    });
                }
            });
        }
    };
    SisMultiSelectEntitySearchComponent.prototype.onEntityRemove = function (event, entity) {
        var index = this.selectedEntities.indexOf(entity);
        this.selectedEntities.splice(index, 1);
        this.entitySearchCtrl.setValue('');
        this.emitSelectedEntitiesIds();
        event.stopPropagation();
    };
    SisMultiSelectEntitySearchComponent.prototype.onEntitySelect = function (entity) {
        var _this = this;
        this.entitySearchCtrl.setValue('');
        var entitySearchItem = entity;
        entitySearchItem.displayName = this.nameFieldIds.map(function (nameMetaFieldId) {
            return _this.multilingualFields.indexOf(nameMetaFieldId.getSystemName()) > -1 ?
                entity.entity[nameMetaFieldId.getSystemName()][_this.currentLanguageId] : entity.entity[nameMetaFieldId.getSystemName()];
        }).join(" | ");
        this.selectedEntities.push(entitySearchItem);
        this.emitSelectedEntitiesIds();
        this.entitiesInput.nativeElement.value = '';
        this.entitiesInput.nativeElement.focus();
        this.entities = [];
        this.totalRows = 0;
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
    };
    SisMultiSelectEntitySearchComponent.prototype.clearEntitySearchCtrl = function () {
        this.selectedEntities = [];
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.totalRows = 0;
        this.entities = [];
        this.entitySearchCtrl.setValue('');
        this.entitiesInput.nativeElement.value = '';
        this.valueChange.emit([]);
    };
    SisMultiSelectEntitySearchComponent.prototype.emitSelectedEntitiesIds = function () {
        var entityIds = new Array();
        this.selectedEntities.forEach(function (selectedEntity) {
            entityIds.push(selectedEntity.id);
        });
        this.valueChange.emit(entityIds);
    };
    SisMultiSelectEntitySearchComponent.prototype.openEntityList = function (entitiesFormFiled) {
        this.entitiesListMenuWidth = +entitiesFormFiled.underlineRef.nativeElement.offsetWidth;
        this.matMenuTrigger.openMenu();
    };
    // Method just correct mat-menu position applying some style on if needed
    SisMultiSelectEntitySearchComponent.prototype.correctMenuPosition = function () {
        var _this = this;
        setTimeout(function () {
            var entitiesElRect = _this.entitiesFormFiled.underlineRef.nativeElement.parentElement.getBoundingClientRect();
            var menuElRect = document.getElementsByClassName("sis-multi-entity-search__menu-panel")[0].getBoundingClientRect();
            var headerElRect = document.getElementsByClassName("mat-tab-list")[0] ? document.getElementsByClassName("mat-tab-list")[0].getBoundingClientRect() : null;
            var pageHeaderElRect = document.getElementsByClassName("page-view-header")[0] ? document.getElementsByClassName("page-view-header")[0].getBoundingClientRect() : null;
            if ((pageHeaderElRect && menuElRect.bottom == pageHeaderElRect.bottom) || (headerElRect && menuElRect.bottom == headerElRect.bottom)) {
                return;
            }
            if (headerElRect && entitiesElRect.top < headerElRect.bottom && menuElRect.top < entitiesElRect.bottom) {
                var bottom = window.innerHeight - headerElRect.bottom;
                document.getElementsByClassName("mat-menu-panel")[0].parentElement.style.bottom = bottom + "px";
            }
            else if (headerElRect && entitiesElRect.top > headerElRect.bottom && entitiesElRect.top <= menuElRect.bottom && menuElRect.top <= entitiesElRect.bottom) {
                var bottom = window.innerHeight - entitiesElRect.top;
                document.getElementsByClassName("mat-menu-panel")[0].parentElement.style.bottom = bottom + "px";
            }
            else if (pageHeaderElRect && entitiesElRect.top < pageHeaderElRect.bottom && menuElRect.top < entitiesElRect.bottom) {
                var bottom = window.innerHeight - pageHeaderElRect.bottom;
                document.getElementsByClassName("mat-menu-panel")[0].parentElement.style.bottom = bottom + "px";
            }
        });
    };
    __decorate([
        core_1.ViewChild('entitiesInput'),
        __metadata("design:type", core_1.ElementRef)
    ], SisMultiSelectEntitySearchComponent.prototype, "entitiesInput", void 0);
    __decorate([
        core_1.ViewChild('entitiesFormFiled'),
        __metadata("design:type", material_1.MatFormField)
    ], SisMultiSelectEntitySearchComponent.prototype, "entitiesFormFiled", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatMenuTrigger),
        __metadata("design:type", material_1.MatMenuTrigger)
    ], SisMultiSelectEntitySearchComponent.prototype, "matMenuTrigger", void 0);
    SisMultiSelectEntitySearchComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-multiselect-entity-search',
            styles: [require('./sis-multiselect-entity-search.component.css')],
            template: require('./sis-multiselect-entity-search.component.html'),
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService, entity_service_1.EntitySearchService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.LanguageService])
    ], SisMultiSelectEntitySearchComponent);
    return SisMultiSelectEntitySearchComponent;
}(sis_entity_search_component_1.SisEntitySearchComponent));
exports.SisMultiSelectEntitySearchComponent = SisMultiSelectEntitySearchComponent;
//# sourceMappingURL=sis-multiselect-entity-search.component.js.map